import { useCallback, useState, useMemo } from 'react';
export var useSideBar = function (_a) {
    var _b = _a.isOpenBydefault, isOpenBydefault = _b === void 0 ? false : _b, _c = _a.forceIsClosed, forceIsClosed = _c === void 0 ? false : _c, _d = _a.forceIsOpen, forceIsOpen = _d === void 0 ? false : _d, _e = _a.hideToggleButton, hideToggleButton = _e === void 0 ? false : _e, _f = _a.onIsOpenChange, onIsOpenChange = _f === void 0 ? function (_a) {
        var prevState = _a.prevState, nextState = _a.nextState;
        return ({
            prevState: prevState,
            nextState: nextState,
        });
    } : _f;
    var _g = useState(isOpenBydefault), toggleActive = _g[0], setToggleActive = _g[1];
    var handleToggle = useCallback(function () {
        setToggleActive(!toggleActive);
        onIsOpenChange === null || onIsOpenChange === void 0 ? void 0 : onIsOpenChange({ prevState: toggleActive, nextState: !toggleActive });
    }, [toggleActive, onIsOpenChange]);
    var activeNavigation = useMemo(function () { return (forceIsClosed || forceIsOpen ? !forceIsClosed || forceIsOpen : toggleActive); }, [forceIsClosed, forceIsOpen, toggleActive]);
    var hasToggleButton = useMemo(function () { return !forceIsOpen && !hideToggleButton && !forceIsClosed; }, [
        forceIsClosed,
        forceIsOpen,
        hideToggleButton,
    ]);
    return {
        toggleActive: toggleActive,
        handleToggle: handleToggle,
        activeNavigation: activeNavigation,
        hasToggleButton: hasToggleButton,
    };
};
